import type { FC } from "react";

import Link, { type LinkProps } from "@mui/material/Link";

import darkTheme from "@styles/theme/colors";

interface ExternalLinkProps extends LinkProps {
	href?: string;
	target?: string;
	rel?: string;
	warning?: boolean;
}

const ExternalLink: FC<ExternalLinkProps> = ({
	children,
	href = "#",
	rel = "noreferrer",
	target = "_blank",
	warning,
	...props
}) => {
	return (
		<Link
			href={href}
			target={target}
			rel={rel}
			color={warning ? "#FFFF66" : darkTheme.Color.White}
			sx={{
				textDecoration: "none",
				...props?.sx,
			}}
			{...props}
		>
			{children}
		</Link>
	);
};

export default ExternalLink;
